import { ReactNode } from "react";
import MainContainer from "components/common/MainContainer";
import PageHeader from "components/common/PageHeader";
import BaseButton from "components/common/BaseButton";
import { ButtonConfig } from "./components/HeaderButtons";

interface Props {
  header: ReactNode;
  children: ReactNode;
  headerActions?: ReactNode;
  headerButtons?: ButtonConfig[];
  containerClassName?: string;
}

const AdminLayout = ({
  header,
  headerActions,
  headerButtons = [],
  children,
  containerClassName = "usadmin-entities-main-container",
}: Props) => {
  const headerButtonsMarkup = headerButtons && headerButtons.length > 0 && (
    <div className={`${containerClassName}__buttons`}>
      {headerButtons.map((btn) => (
        <BaseButton
          key={btn.id}
          text={btn.text}
          backgroundColor={btn.backgroundColor}
          handleSubmit={btn.handleClick}
          className={btn.className}
        />
      ))}
    </div>
  );

  return (
    <MainContainer
      pageTitle={
        <div className={containerClassName}>
          <div className={`${containerClassName}__header`}>
            {headerButtonsMarkup}
            <PageHeader header={header} />
          </div>
          {headerActions && (
            <div className={`${containerClassName}__actions`}>
              {headerActions}
            </div>
          )}
        </div>
      }
    >
      {children}
    </MainContainer>
  );
};

export default AdminLayout;
